import { render, staticRenderFns } from "./FAQMenuSubject.vue?vue&type=template&id=13ef0654&scoped=true&"
import script from "./FAQMenuSubject.vue?vue&type=script&lang=js&"
export * from "./FAQMenuSubject.vue?vue&type=script&lang=js&"
import style0 from "./FAQMenuSubject.vue?vue&type=style&index=0&id=13ef0654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ef0654",
  null
  
)

export default component.exports